// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Stack } from "@mui/system";
import { IconArrowRight, IconCurrencyRupee } from "@tabler/icons";
import { useEffect, useState } from "react";
import { axiosInstance } from "src/api/axios";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../../../assets/style.css";

// import required modules
import { Percent } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { Navigation, Pagination } from "swiper/modules";

export default function Carousel({ filter }) {
  const [product, setProduct] = useState([]);
  const lgUp = useMediaQuery((media) => media.breakpoints.up("lg"));
  const theme = useTheme();
  const navigate = useNavigate();
  useEffect(() => {
    axiosInstance.get("/product").then((response) => {
      let filtered_products = [];

      if (filter && filter === "top") {
        filtered_products = Array.isArray(response.data)
          ? response.data.filter((i) => i.top && i?.images.length)
          : [];
      } else {
        console.log(response.data);
        filtered_products = Array.isArray(response.data)
          ? response.data
              .slice(0, 9)
              .filter((i) => i?.images.length)
              .filter((i) => i?.status === "Active")
          : [];
      }
      // let filtered_products = response.data
      let numSlides = Math.ceil(filtered_products.length / 3);

      let sorted_products = [];
      for (let i = 0; i <= numSlides; i++) {
        if (!filtered_products.length) break;
        let chunk = [filtered_products[0]];
        filtered_products.length > 1 && filtered_products[1]
          ? chunk.push(filtered_products[1])
          : [].push();
        filtered_products.length > 2 && filtered_products[2] && lgUp
          ? chunk.push(filtered_products[2])
          : [].push();
        // filtered_products.length > 3 && filtered_products[3] && lgUp
        //   ? chunk.push(filtered_products[2])
        //   : [].push();
        // chunk.forEach((i) =>
        //   i.images.map((i) => i.split(imageSeperator)[1].replace("\\\\", "\\"))
        // );
        sorted_products.push(chunk);

        filtered_products = filtered_products.slice(lgUp ? 3 : 2);
      }
      setProduct(sorted_products);
    });
  }, []);

  const swiperModules = [Pagination];
  if (lgUp) {
    swiperModules.push(Navigation);
  }

  return (
    <>
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={swiperModules}
        navigation={lgUp ? true : false}
        className="mySwiper"
        autoplay={true}
        style={{
          borderRadius: "10px",
          width: "100%",
          height: "250px",
        }}
      >
        {product.map((_, slideIndex) => (
          <SwiperSlide
            key={slideIndex}
            style={{
              background: "#ddd1",
              minHeight: "180px",
              maxWidth: "100%",
            }}
          >
            <Stack
              direction={"row"}
              spacing={1}
              justifyContent={lgUp ? "space-evenly" : "space-around"}
            >
              {_.map((items, index) =>
                items && items?.images?.length ? (
                  <Card
                    variant="outlined"
                    sx={{
                      maxHeight: {
                        lg: "140px",
                        sm: "120px",
                        xs: "105px",
                      },
                      maxWidth: {
                        lg: "310px",
                        md: "290px",
                        sm: "200px",
                        xs: "150px",
                      },
                      minWidth: {
                        lg: "310px",
                        md: "290px",
                        xs: "150px",
                      },
                      padding: {
                        md: "16px 6px",
                        xs: "12px 3px",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        padding: {
                          md: "16px",
                          xs: "12px 6px",
                        },
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={5} sx={{ maxHeight: "85px" }}>
                          <Tooltip
                            title={`Earnpati Affiliate for ${items.title}`}
                          >
                            <Box>
                              <img
                                src={
                                  typeof items?.images[0] === "object"
                                    ? URL.createObjectURL(items.images[0])
                                    : items.images[0]
                                }
                                alt={`Earnpati Affiliate for ${items.title}`}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  maxHeight: lgUp ? "115px" : "55px",
                                  maxWidth: lgUp ? "115px" : "55px",
                                  borderRadius: "5px",
                                  fontSize: "12px",
                                }}
                              />
                            </Box>
                          </Tooltip>
                        </Grid>

                        <Grid
                          item
                          xs={7}
                          direction={"column"}
                          alignItems={"stretch"}
                          sx={{ maxHeight: "85px" }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: {
                                md: "1rem",
                                xs: "12px",
                              },
                              lineHeight: {
                                md: "18px",
                                xs: "16px",
                              },
                              height: { md: "40px", xs: "15px" },
                            }}
                          >
                            {items.title}
                          </Typography>
                          {lgUp ? (
                            <Typography
                              sx={{
                                my: 1,
                                ml: "14px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "break-spaces",
                                maxHeight: {
                                  md: "45px",
                                  xs: "35px",
                                },
                                fontSize: {
                                  md: "1rem",
                                  xs: "12px",
                                },
                                maxWidth: "100%",
                                display: "flex",
                                alignItems: "center",
                                lineHeight: "14px",
                              }}
                            >
                              <span style={{ fontWeight: "bolder", mr: 15 }}>
                                {items.earntype || "Earn Upto"}:
                              </span>
                              {!items?.isPercentage ? (
                                <>
                                  <IconCurrencyRupee
                                    style={{ width: "1rem", minWidth: "1rem" }}
                                  />{" "}
                                  {items.earnUpto}
                                </>
                              ) : (
                                <>
                                  {items.earnUpto}
                                  <Percent
                                    style={{ width: "1rem", minWidth: "1rem" }}
                                  />{" "}
                                </>
                              )}
                            </Typography>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} mt={{ md: ".2rem", sm: "1rem" }}>
                          <Stack
                            direction="row"
                            justifyContent={lgUp ? "end" : "space-between"}
                            sx={{
                              marginLeft: {
                                lg: "-1rem",
                                xs: 0,
                              },
                            }}
                          >
                            {!lgUp ? (
                              <Typography
                                sx={{
                                  my: 0.5,
                                  ml: -0.3,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "break-spaces",
                                  mr: 1,
                                  maxHeight: {
                                    md: "45px",
                                    xs: "35px",
                                  },
                                  fontSize: {
                                    md: "1rem",
                                    xs: "10px",
                                  },
                                  maxWidth: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  lineHeight: "14px",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bolder",
                                    mr: 15,
                                    ml: -5,
                                  }}
                                >
                                  Earn:
                                </span>
                                <IconCurrencyRupee
                                  style={{ width: "1rem", minWidth: "1rem" }}
                                />{" "}
                                {items.earnUpto}
                              </Typography>
                            ) : null}
                            <Button
                              variant="contained"
                              sx={{
                                bgcolor: theme.palette.earnpati.main,
                                width: "50%",

                                padding: {
                                  md: "6px 16px",
                                  xs: "6px",
                                },
                                alignSelf: "start",
                                fontSize: {
                                  md: "1rem",
                                  xs: "12px",
                                },
                                "&:hover": {
                                  backgroundColor:
                                    theme.palette.earnpati.success,
                                  cursor: "pointer",
                                },
                              }}
                              onClick={() => {
                                navigate(`/products/${items.id}`);
                              }}
                            >
                              Details <IconArrowRight />
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : null
              )}
            </Stack>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
